export default __webpack_public_path__ + "static/media/art-bottomless2.17c8aa79.jpg";